"use client";

import {
  BriefcaseMedicalIcon,
  FileBarChart2Icon,
  StethoscopeIcon,
} from "lucide-react";
import { ClinicalCaseTopInfoCard } from "./clinical-case-top-info-card";
import { useContext } from "react";
import { UserContext } from "@/contexts/user-context";

export const ClinicalCaseTopInfoSection = ({
  finished,
  totalCount,
  score,
  categories,
}: {
  finished: ClinicalCasePreviewVM[];
  totalCount: number;
  score: number;
  categories: ClinicalCaseCategoryPreviewVM[];
}) => {
  const { isLoggedIn } = useContext(UserContext);

  if (!isLoggedIn) {
    return <div className="-my-6"></div>;
  }

  return (
    <div className="flex flex-col justify-between gap-6 md:flex-row">
      <ClinicalCaseTopInfoCard
        title="Przyjęci pacjenci"
        mainContent={finished.length.toString() + " / " + totalCount}
        subText="ukończonych wizyt"
        icon={<BriefcaseMedicalIcon className="h-4 w-4" color="#2E35FF" />}
      />
      <ClinicalCaseTopInfoCard
        title="Skuteczność"
        mainContent={Math.round(score).toString() + "%"}
        subText="poprawnych odpowiedzi"
        icon={<FileBarChart2Icon className="h-4 w-4" color="#2E35FF" />}
      />
      <ClinicalCaseTopInfoCard
        title="Dostępne kategorie"
        mainContent={categories.length.toString()}
        subText="liczba specjalizacji"
        icon={<StethoscopeIcon className="h-4 w-4" color="#2E35FF" />}
      />
    </div>
  );
};
